export const AVATAR_PRESETS = [
  { id: "p1", gradient: "from-violet-500 via-fuchsia-500 to-pink-500" },
  { id: "p2", gradient: "from-cyan-500 via-blue-500 to-indigo-500" },
  { id: "p3", gradient: "from-amber-400 via-orange-500 to-pink-500" },
  { id: "p4", gradient: "from-emerald-500 via-teal-500 to-cyan-500" },
  { id: "p5", gradient: "from-pink-500 via-rose-500 to-red-500" },
  { id: "p6", gradient: "from-indigo-500 via-purple-500 to-fuchsia-500" },
  { id: "p7", gradient: "from-yellow-400 via-amber-500 to-orange-600" },
  { id: "p8", gradient: "from-lime-400 via-emerald-500 to-teal-600" },
];

export function getPreset(url) {
  if (!url) return null;
  if (url.startsWith("preset:")) {
    const id = url.slice(7);
    return AVATAR_PRESETS.find((p) => p.id === id) || AVATAR_PRESETS[0];
  }
  return null;
}

export function Avatar({ user, size = 44, ringClass = "" }) {
  const url = user?.avatar_url;
  const preset = getPreset(url);
  const letter = (user?.name || "?")[0]?.toUpperCase();
  const style = { width: size, height: size };

  if (url && !preset) {
    return (
      <div
        className={`rounded-full overflow-hidden bg-slate-800 ${ringClass}`}
        style={style}
      >
        <img src={url} alt="" className="w-full h-full object-cover" />
      </div>
    );
  }
  const grad = preset?.gradient || "from-violet-500 to-fuchsia-500";
  return (
    <div
      className={`rounded-full bg-gradient-to-br ${grad} flex items-center justify-center ${ringClass}`}
      style={style}
    >
      <span
        className="font-arcade text-white font-bold"
        style={{ fontSize: Math.round(size * 0.42) }}
      >
        {letter}
      </span>
    </div>
  );
}
